import { Route, Switch, useRouteMatch, withRouter } from 'react-router-dom';
import UserException from './user-exception/UserException';
import AdminHeader from './AdminHeader';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { compose } from 'redux';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';
import { fetchUserProfileData } from '../../actions/profile/profile.action';
import Application from './application/application';
import ToastNotification from '../shared/ToastNotification';
import ZoomLogging from './zoom-logging/ZoomLogging';

const Admin = ({ fetchUserProfileData, userProfile, history, authState }) => {
    let { path, url } = useRouteMatch();

    useEffect(() => {
        if (userProfile !== null && (!userProfile?.roles?.length || !userProfile.roles.indexOf('admin') <= 0)) {
            history.replace('/');
        }

        if (userProfile === null && authState.accessToken) {
            fetchUserProfileData(authState.accessToken);
        }

    }, [userProfile]);

    console.log(`${path}/application`);
    return userProfile?.roles?.indexOf('admin') >= 0 ? (<>
        <AdminHeader />
        <Container fluid>
            <Row>
                <Col>
                    <Switch>
                        <Route exact path={path}>
                            <UserException />
                        </Route>
                        <Route path={`${path}/application`}>
                            <Application />
                        </Route><Route path={`${path}/zoom-log`}>
                            <ZoomLogging />
                        </Route>
                    </Switch>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ToastNotification />
                </Col>
            </Row>
        </Container>
    </>) : <></>;
};
const mapStateToProps = (state) => ({
    userProfile: state.userProfile.profile,
});


export default compose(withRouter, withOktaAuth, connect(mapStateToProps, { fetchUserProfileData }))(Admin);